import request from '@/utils/request'
import { baseURL } from '@/utils/getawayModule'

/***
 *
 * 分页查询球场比赛 get
 * @param query 分页参数
 * @return request
 * */
export function getRacesList(query) {
  return request({
    url: `${baseURL.businessApi}/races`,
    method: 'get',
    params: query
  })
}


/**
 * 删除球场比赛
 * @param id
 * @returns {AxiosPromise}
 */
export function deleteRacesById(id) {
  return request({
    url: `${baseURL.businessApi}/races/${id}`,
    method: 'delete'
  })
}


export function sendRaceMail(data, params) {
  return request({
    url: `${baseURL.businessApi}/races/sendRaceMail`,
    method: 'post',
    data: data,
    params: params
  })
}
